const OrderDetailDiscountType = Object.freeze({
  PRODUCT_COUPON: 'PRODUCT_COUPON',
  DELIVERY_COUPON: 'DELIVERY_COUPON',
  BAEMIN_POINT: 'BAEMIN_POINT',
  BAEMIN_GIFTCARD: 'BAEMIN_GIFTCARD'
})

const OrderDetailDiscount = class {
  constructor({ amount, type, description }) {
    this.amount = amount
    this.type = type
    this.description = description
  }

  isProductCouponType() {
    return OrderDetailDiscountType.PRODUCT_COUPON === this.type
  }

  isDeliveryCouponType() {
    return OrderDetailDiscountType.DELIVERY_COUPON === this.type
  }

  isBaeminPointType() {
    return OrderDetailDiscountType.BAEMIN_POINT === this.type
  }

  isBaeminGiftCardType() {
    return OrderDetailDiscountType.BAEMIN_GIFTCARD === this.type
  }
}

export default null

export const ofOrderDetailDiscount = (params = {}) => new OrderDetailDiscount(params)
